module.exports = __webpack_public_path__ + "static/media/ic_address.f245f826.973fb2cf.svg";